import "../scss/main.scss";

// markeer dat JS actief is (zet dit script in <head> of zo vroeg mogelijk)
document.documentElement.classList.add("js");

(() => {
    const onReady = () => {
        const sections = document.querySelectorAll(
            ".hero-wrap, .intro-wrap, .what-wrap, .how-wrap"
        );

        // Klassen + afwisselende richting
        sections.forEach((el, i) => {
            el.classList.add(
                "reveal",
                i % 2 === 0 ? "from-left" : "from-right"
            );
        });

        const reveal = (el) => el.classList.add("in");

        // Fallback als IO niet bestaat
        if (!("IntersectionObserver" in window)) {
            sections.forEach(reveal);
            return;
        }

        // Observer met iets ruimere marges (pakt vroege binnenkomst)
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting || entry.intersectionRatio > 0) {
                        reveal(entry.target);
                        io.unobserve(entry.target);
                    }
                });
            },
            {
                root: null,
                // begin 10% voor de onderkant alvast met revealen
                rootMargin: "0px 0px -40% 0px",
                threshold: [0, 0.01, 0.15],
            }
        );

        // Observe + onmiddellijke eerste check (voor elementen al in viewport)
        sections.forEach((el) => {
            io.observe(el);
            const r = el.getBoundingClientRect();
            if (r.top < window.innerHeight * 0.9 && r.bottom > 0) {
                reveal(el);
                io.unobserve(el);
            }
        });

        // Safety net: als er iets blokkeert, maak na 2s alles zichtbaar
        setTimeout(() => sections.forEach(reveal), 2000);
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", onReady);
    } else {
        onReady();
    }
})();
